import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import { useState } from "react";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
export default function Tooltip(props) {
  var children = props.children,
    tooltipContainerStyles = props.tooltipContainerStyles,
    tooltipText = props.tooltipText,
    position = props.position,
    verticalPosition = props.verticalPosition,
    tooltipStyles = props.tooltipStyles,
    _props$tooltipBg = props.tooltipBg,
    tooltipBg = _props$tooltipBg === void 0 ? "bg-gray-700" : _props$tooltipBg,
    onMouseEnter_ = props.onMouseEnter,
    onMouseLeave_ = props.onMouseLeave,
    onClick_ = props.onClick,
    className = props.className;
  var _useState = useState(false),
    isHovered = _useState[0],
    setIsHovered = _useState[1];
  var arrowBg = tooltipBg === null || tooltipBg === void 0 ? void 0 : tooltipBg.split("-").slice(1, 3).join("-");
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(tooltipContainerStyles, {
      relative: !(tooltipContainerStyles !== null && tooltipContainerStyles !== void 0 && tooltipContainerStyles.includes("absolute")) && !(tooltipContainerStyles !== null && tooltipContainerStyles !== void 0 && tooltipContainerStyles.includes("fixed")) && !(tooltipContainerStyles !== null && tooltipContainerStyles !== void 0 && tooltipContainerStyles.includes("static")) && !(tooltipContainerStyles !== null && tooltipContainerStyles !== void 0 && tooltipContainerStyles.includes("relative"))
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("m-2", _defineProperty({}, className, !!className)),
    onMouseEnter: function onMouseEnter() {
      if (typeof onMouseEnter_ === "function") onMouseEnter_();
      setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      if (typeof onMouseLeave_ === "function") onMouseLeave_();
      setIsHovered(false);
    },
    onClick: function onClick() {
      if (typeof onClick_ === "function") onClick_();
    }
  }, children), isHovered && !isMobile && /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-col absolute z-[9999]", {
      "": verticalPosition === "bottom",
      "top-0 translate-y-[-100%]": verticalPosition === "top",
      "left-0": position === "left",
      "right-0": position === "right"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("w-0 h-0 border-l-[5px] border-l-[transparent] border-r-[5px] border-r-[transparent]", _defineProperty({
      "order-1 border-b-[5px]": verticalPosition === "bottom",
      "order-2 border-t-[5px]": verticalPosition === "top",
      "mr-auto ml-4": position === "left",
      "ml-auto mr-4": position === "right"
    }, "border-".concat(arrowBg), !!arrowBg))
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames("min-w-max ".concat(tooltipStyles, " ").concat(tooltipBg), {
      "order-2": verticalPosition === "bottom",
      "order-1": verticalPosition === "top"
    })
  }, tooltipText)));
}